import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { aiqApi } from '@/api/aiq'
import { ArrowLeft, Loader2, AlertCircle } from 'lucide-react'
import { AiqIndividualReportView } from '@quebon/shared-learning'

export default function AiqReport() {
  const { productId } = useParams<{ productId: string }>()
  const navigate = useNavigate()

  // Fetch report data
  const { data: reportData, isLoading, error } = useQuery({
    queryKey: ['aiqReport', 'individual', productId],
    queryFn: async () => {
      if (!productId) return null
      const response = await aiqApi.getIndividualReport(Number(productId))
      return response.data.data
    },
    enabled: !!productId,
  })

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">리포트를 불러오는 중...</p>
        </div>
      </div>
    )
  }

  if (error || !reportData) {
    const errorMessage = error instanceof Error ? error.message : '리포트를 불러오는데 실패했습니다'
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center max-w-md">
          <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
          <p className="text-gray-800 font-medium mb-2">리포트 조회 실패</p>
          <p className="text-sm text-gray-500 mb-4">{errorMessage}</p>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
          >
            돌아가기
          </button>
        </div>
      </div>
    )
  }

  return (
    <AiqIndividualReportView
      data={reportData}
      backButton={
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          돌아가기
        </button>
      }
    />
  )
}
